import { NoseurObject, Scheme } from "@ronuse/noseur"
import { SetURLSearchParams } from "react-router-dom";
import { ILog } from "../services";

export type URLSearchParamsValue = string | string[] | number | number[] | undefined | null;

export const Utils = {

    BUTTON_LOADING_PROPS: {
        disabled: true,
        rightIcon: "fas fa-spinner fa-pulse"
    },

    BUTTON_LOADING_PROPS_ICON_ONLY: {
        text: "",
        disabled: true,
        rightIcon: "fas fa-spinner fa-pulse"
    },

    randomNumber(min: number = 1, max: number = 1000) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    },

    updateSearchParams(key: string, value: URLSearchParamsValue, setSearchParams: SetURLSearchParams | URLSearchParams, cb?: Function | undefined) {
        const fun = (prev: URLSearchParams) => {
            if (value === undefined || value === null) {
                prev.delete(key);
            } else if (Array.isArray(value)) {
                prev.delete(key);
                for (const v of value) prev.append(key, `${v}`);
            } else {
                prev.set(key, `${value}`);
            }
            return prev;
        };
        if (setSearchParams instanceof URLSearchParams) fun(setSearchParams);
        else setSearchParams(fun);
        cb && cb();
    },

    normalizeUrlParams(urlSearchParams: URLSearchParams, keyLookupMap: NoseurObject<string> = {}, extraParams: NoseurObject<string | number> = {}, reverseKeyLookupMap: NoseurObject<string> = {}) {
        const params: NoseurObject<any> = {};
        Object.keys(Object.fromEntries(urlSearchParams)).forEach((key: string) => {
            const lookupKey = keyLookupMap[key] ?? key;
            const values = urlSearchParams.getAll(reverseKeyLookupMap[lookupKey] ? lookupKey : key);
            if (values.length) {
                params[reverseKeyLookupMap[lookupKey] ?? lookupKey] = values.length > 1 ? values : values[0];
            }
        });
        Object.keys(extraParams).forEach((key) => params[key] = extraParams[key])
        return params;
    },

    urlParamsToSearch(urlSearchParams: URLSearchParams, only?: string[], includes?: NoseurObject<URLSearchParamsValue>) {
        only && only.length && Object.keys(Object.fromEntries(urlSearchParams)).forEach((key: string) => {
            if (!only.includes(key)) urlSearchParams.delete(key);
        });
        if (includes) {
            Object.keys(includes).forEach((key: string) => Utils.updateSearchParams(key, includes[key], urlSearchParams));
        }
        return urlSearchParams.toString();
    },

    logsToCsv(data: ILog[], labels: any, separator: string = ',') {
        const rows = [[labels.timestamp, labels.level, labels.group, labels.trace_id, labels.span_id, labels.content]]
            .concat(data.map(row => [row.created_at ?? "", row.level ?? "", row.group ?? "", row.trace_id ?? "", row.span_id ?? "", row.content ?? ""]));
        return rows.map(row => row.map(String)
            .map((v: any) => v.replaceAll('"', '""'))
            .map((v: any) => `"${v}"`)
            .join(separator)
        ).join('\r\n');
    },

    downloadBlob(content: string, filename: string, contentType: string = "text/csv;charset=utf-8;") {
        const blob = new Blob([content], { type: contentType });
        const url = URL.createObjectURL(blob);
        const pom = document.createElement('a');
        pom.href = url;
        pom.setAttribute('download', filename);
        pom.click();
    },

    exportLogs(logs: ILog[], labels: any) {
        const date = new Date();
        const year = date.getFullYear();
        const day = date.toLocaleString("en-US", { day: "2-digit" });
        const month = date.toLocaleString("en-US", { month: "long" });
        const minutes = date.toLocaleString("en-US", { minute: "2-digit" });
        const seconds = date.toLocaleString("en-US", { second: "2-digit" });
        const hours = date.toLocaleString("en-US", { hour: "2-digit" }).split(" ")[0];
        const meridian = date.toLocaleString("en-US", { hour: "2-digit" }).split(" ")[1];
        Utils.downloadBlob(Utils.logsToCsv(logs, labels), `mnemosyne_logs__${month}_${day}_${year}__${hours}_${minutes}_${seconds}_${meridian}`);
    },

};

export * from "./Encryptor";
export type { Encryptor } from "./Encryptor";
export { CacheManager } from "./CacheManager";
export const Schemes: {
    RIVTN_MNEMOSYNE: Scheme;
} = {
    RIVTN_MNEMOSYNE: "rivtn-mnemosyne" as Scheme
}
